import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Импорт хука для получения текущего пути
import { Link } from "react-router-dom";
import styles from "./footer.module.scss";
import Logotype from "../../assets/images/Logotype.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Modal from "../../components/homePage/ModalForm/ModalForm";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import { FiMenu, FiX } from "react-icons/fi";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import {
  selectHeader,
  selectHeaderLoading,
  selectHeaderMedia,
} from "../../store/selectors/content/headerSelectors";
import {
  fetchHeader,
  fetchHeaderMedia,
} from "../../store/api/content/headerApi";

const Footer = ({ transparent, color, isMenuOpen, setIsMenuOpen }) => {
  const location = useLocation();
  const [activePath, setActivePath] = React.useState(location.pathname);
  const isProductPage = /^\/product\/[^/]+$/.test(location.pathname);
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || i18n.language
  );
  const dispatch = useDispatch();
  const headerData = useSelector((state) => selectHeader(state, language));
  const headerMedia = useSelector(selectHeaderMedia);
  const isLoading = useSelector(selectHeaderLoading);
  const device = useDeviceDetection();
  const [isModalVisible, setIsModalVisible] = useState(false);
  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (!headerData) {
      dispatch(fetchHeader(language));
    }
  }, [dispatch, language, headerData]);

  useEffect(() => {
    if (!headerMedia) {
      dispatch(fetchHeaderMedia());
    }
  }, [dispatch, headerMedia]);

  const handleModalOpen = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    const direction = language === "heb" ? "rtl" : "ltr";
    document.documentElement.dir = direction;

    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n.language]);

  const switchLanguage = (lng) => {
    setLanguage(lng);
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  const navigate = useNavigate();
  const handleClickOnHome = () => {
    navigate("/");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const ImagePath = "/images/logoBlueBG.svg"
  return (
    <div className={transparent ? styles.footerTransparent : styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerLogo}>
          <Link to="/">
            {headerMedia?.logo && <img src={`${isProductPage ? ImagePath : headerMedia.logo}`} alt="logo" />}
          </Link>
        </div>
        {device === "Mobile" ? (
          <div className={styles.burgerMenu}>
            <button
              onClick={toggleMenu}
              className={styles.burgerButton}
              style={{ color: isMenuOpen || isProductPage ? "white" : "rgb(54,59,97)" }}
            >
              {isMenuOpen ? <FiX size={30} /> : <FiMenu size={30} />}
            </button>
            <motion.nav
              className={styles.mobileNav}
              initial={{ x: "100%" }}
              animate={{ x: isMenuOpen ? "0%" : "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
              <div className={styles.mobileMenuLogo0} onClick={handleClickOnHome}>
                <img src="/images/logoBlueBG.svg" alt="logo" />
              </div>
              <ul className={styles.mobileLinks}>
                {headerData && (
                  <>
                    {headerData?.button?.map((item) => (
                      <li key={item.slug}>
                        <Link
                          to={`/${item.slug === "home" ? "" : item.slug}`}
                          onClick={toggleMenu}
                          style={{
                            fontWeight:'600',
                            color:
                              activePath ===
                              (item.slug === "home" ? "/" : `/${item.slug}`)
                                ? "#F77F1E"
                                : color,
                          }}
                        >
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </>
                )}
              </ul>
              <div className={styles.menuBottomBlock}>
                <div>
                  <select
                  className={styles.selectMobile}
                  value={language}
                  onChange={(e) => switchLanguage(e.target.value)}
                  style={{
                    border: "none",
                    background: "transparent",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#363B61",
                    outline: "none"
                  }}
                >
                  <option value="en" style={{color:"#363B61",}}>EN</option>
                  <option value="heb" style={{color:"#363B61",}}>עב</option>
                </select>
                </div>
                <div
                  className={`${styles.button} ${language === "heb" ? styles.hebFont : styles.enFont}`}
                  onClick={handleModalOpen}
                  onClose={handleModalClose}
                >
                  <span className={styles.buttonText}>
                    {headerData && <>{headerData?.button_text}</>}
                  </span>
                </div>
                <Modal isVisible={isModalVisible} onClose={handleModalClose} />
              </div>
            </motion.nav>
          </div>
        ) : (
          <nav className={styles.footerNav}>
            <ul className={styles.footerLinks}>
              {headerData && (
                <>
                  {headerData?.button?.map((item) => (
                    <li key={item.slug}>
                      <Link
                        to={`/${item.slug === "home" ? "" : item.slug}`}
                        className={`${styles.footerLinksA} ${language ? styles.hebFont : styles.enFont}`}
                        style={{
                          fontWeight: "600",
                          color:
                            activePath ===
                            (item.slug === "home" ? "/" : `/${item.slug}`)
                              ? "#F77F1E"
                              : color,
                        }}
                      >
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </>
              )}
            </ul>
          </nav>
        )}
        {device !== "Mobile" && (
          <div
            className={styles.headerButton}
            style={{ flex: "1.5" }}
            onClick={handleModalOpen}
            onClose={handleModalClose}
          >
            <div className={`${styles.button} ${language === "heb" ? styles.hebFont : styles.enFont}`}>
              <span className={styles.buttonText}>
                {headerData && <>{headerData?.button_text}</>}
              </span>
            </div>
          </div>
        )}
        {device !== "Mobile" && (
          <div>
            <select
              value={language}
              onChange={(e) => switchLanguage(e.target.value)}
              style={{
                border: "none",
                background: "none",
                fontSize: "16px",
                outline: "none",
                textAlignLast: "right",
                color: isProductPage ? "#FFFFFF" : "#363B61",
                flex: "1",
              }}
            >
              <option value="en" style={{color:"#363B61",}}>EN</option>
              <option value="heb" style={{color:"#363B61",}}>עב</option>
            </select>
          </div>
        )}
      </div>
      <Modal isVisible={isModalVisible} onClose={handleModalClose} />
    </div>
  );
};

export default Footer;
